// ─────────────────────────────────────────────────────────────────────────────
// MapLegend — the status key pinned to the bottom-left of the map. Static: the
// four statuses are the full set a node can have, and the swatches read their
// colours from STATUS_CONFIG so the legend can never drift from the markers.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./NodeMap.module.css";
import { STATUS_CONFIG } from "../badges";

const STATUSES = ["Optimal", "Warning", "Critical", "Offline"];

export default function MapLegend() {
  return (
    <div className={styles.legend}>
      {STATUSES.map((status) => {
        const { color } = STATUS_CONFIG[status];
        return (
          <span key={status} className={styles.legendItem}>
            <span
              className={styles.legendDot}
              style={{ background: color, boxShadow: `0 0 5px ${color}` }}
            />
            {status}
          </span>
        );
      })}
    </div>
  );
}
